export const COLUMNS_HEADERS = {
  name: { sortable: true, searchable: true },
  username: { sortable: true, searchable: true },
  role: { sortable: true },
};
